import swal from 'sweetalert2';
import Select from 'react-select';
import { useEffect, useState } from "react";
import * as helper from '../global/helper';
import { postGuest, sendGuestOTPForVerification } from '../api/usersAPI';
import { getGuestByCategoryID } from '../api/teeTimeAPI';

const AddGuest = (props) => {

    const [guest,                   setGuest]                       = useState({});
    const [genderOption,            setGenderOption]                = useState([{ value:  'Male', label: 'Male'}, { value:  'Female', label: 'Female'},]);
    const [guestTypeOption,         setGuestTypeOption]             = useState();
    const [otp,                     setOtp]                         = useState('');
    const [isOtpSent,               setIsOtpSent]                   = useState(false);
    const [loadingOtp,              setLoadingOtp]                  = useState(false);
    const [sessionId,               setSessionId]                   = useState('');
    const [otpTimer,                setOtpTimer]                    = useState(0);
    const [canResend,               setCanResend]                   = useState(false);

    useEffect(() => {
        $('#modalGuest').modal({
            backdrop: 'static',
        });

        $('#modalGuest').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            props.onDismissModal(false);
        });
        $('#txtDOB').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });
        $('#txtDOB').on('change', function (event) {
            updateGuestDetails('DOB',  moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }); 
      
    }, [])

    useEffect(() => {
        if(props.mobileCodeList){
            setGuest({CountryCode : props.mobileCodeList[0].Code})
        }
    },[props.mobileCodeList])

    useEffect(() => {
        if (props?.subcategoryList) {
            const guestTypeTransformedOptions = props.subcategoryList?.map(type => ({
                label: type.Name,
                value: type.ID
            })).filter(x => x.value !== 1); // filter out Member option
            setGuestTypeOption(guestTypeTransformedOptions);
        }
    }, [props?.subcategoryList]);

    useEffect(() => {
        setIsOtpSent(false);
        setSessionId('');
    }, [guest.Mobile]);

    useEffect(() => {
        let interval;

        if (otpTimer > 0) {
            interval = setInterval(() => {
                setOtpTimer((prev) => prev - 1);
            }, 1000);
        } else {
            setCanResend(true);
        }

        return () => clearInterval(interval);
    }, [otpTimer]);

    const updateGuestDetails = (field, value) => { 
        setGuest((d) => {
            return { ...d, [field]: value };
        });
    };

    // ✅ Send OTP
    const handleSendOTP = async (isResend = false) => {
        try {
            if (!guest.Mobile) {
                swal.fire("Error", "Enter mobile number", "error");
                return;
            }

            if (!/^[6-9]\d{9}$/.test(guest.Mobile)) {
                swal.fire("Error", "Enter valid mobile number", "error");
                return;
            }

            setLoadingOtp(true);
            const guestID = 0;
            const res = await sendGuestOTPForVerification(guestID ,guest.Mobile);

            if (res?.Message === 'fail') {
                return swal.fire("Error", res?.LongMessage || 'Failed to send OTP', "error");
            }

            // ✅ Reset state on resend
            setSessionId(res.SessionId);
            setIsOtpSent(true);
            setOtp('');
            setOtpTimer(30);
            setCanResend(false);

            swal.fire({
                icon: 'success',
                title: isResend ? 'OTP Resent Successfully' : 'OTP Sent Successfully',
                timer: 1000,
                showConfirmButton: false
            });

        } catch (err) {
            swal.fire("Error", err.message, "error");
        } finally {
            setLoadingOtp(false);
        }
    };

    const addGuestHandler = async(e) => {
        e.preventDefault()
        if (!otp) {
            swal.fire("Error", "Enter OTP", "error");
            return;
        }

        if (!sessionId) {
            swal.fire("Error", "Session expired. Resend OTP", "error");
            return;
        }
        
        const btn = $('#btnSaveGuest');

       try {
        const guestDetails = {
            ID:                    guest.ID || 0,
            Name:                  guest.Name,
            Email:                 guest.Email || '',
            Handicap:              guest.Handicap || '',
            IGUNumber:             guest.IGU || '',
            CountryCode:           guest.CountryCode,
            Mobile:                guest.Mobile,
            Gender:                guest.Gender,
            DOB:                   guest.DOB,
            SubCategoryID:         guest.Type,
            UserRefID:             props.UserRefID ?? null,
            CategoryID:            props.CategoryID,
            Active:                'Y'
        }
        const newG = await postGuest(guestDetails, sessionId, otp);
        helper.StopProcessing(btn);
        $('#modalGuest').modal('hide');
        // if(props.from != '#checkInPayment'){
            props.bookingUserList.push({...newG,  UserID: newG.ID, IsCaddyRequired: "N", IsCartRequired: "N", UserType: "Guest"})
            // props.setShowAddPayment(newG.ID)
        // }else{
        //     props.setPaymentDetails(a => ({...a, UserID: newG.ID}))
        // }
        props.fetchBookingDetails()
        swal.fire({
            icon: 'success',
            titleText: 'Guest added successfully!',
            showConfirmButton: false,
            timer: 1500,
        });
        
       } catch (err) {
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
       }
    }


    return(
        <>
            <div id="modalGuest" className="modal fade modal-responsive" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Guest</h5>
                            <button 
                                type="button" 
                                className="close" 
                                data-dismiss="modal" 
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form className="kt-form" id="add-guest-form">
                                <div id="ModalGuestHolder" className="kt-form kt-form--label-right" role="form">
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Name <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input 
                                                id="txtGuestName" 
                                                name="txtGuestName" 
                                                type="text" 
                                                className="form-control" 
                                                value={guest.Name || ''}
                                                onChange={(event) => updateGuestDetails('Name', helper.camelCase(event.target.value))} 
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Mobile <span className="red">*</span></label>
                                        <div className="col-xl-2 col-lg-3">
                                            <Select
                                                value={(props.mobileCodeList && props.mobileCodeList.length > 0 && guest.CountryCode) && {label: `${props.mobileCodeList.find(m => m.Code == guest.CountryCode).Name} ${props.mobileCodeList.find(m => m.Code == guest.CountryCode).Code}`, value: guest.CountryCode} || ''}
                                                onChange={(event) => updateGuestDetails('CountryCode', event.value)}
                                                name="ddlCountryCode"
                                                id="ddlCountryCode"
                                                className="ddlCountryCode"
                                                options={props.mobileCodeList.map(c => ({
                                                    label: `${c.Name} (${c.Code})`,
                                                    value: c.Code
                                                }))}
                                            />
                                        </div>
                                        <div className="col-xl-4 col-lg-5">
                                            <input 
                                                id="txtGuestMobile" 
                                                name="txtGuestMobile" 
                                                type="number" 
                                                className="form-control"
                                                value={guest.Mobile || ''}
                                                onChange={(event) => updateGuestDetails('Mobile', event.target.value)} 
                                                disabled={isOtpSent}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Gender <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <Select 
                                                id="ddlGender" 
                                                name="ddlGender"
                                                className="multi-custom"
                                                placeholder="Select Gender"
                                                value={guest && genderOption.find((m) => m.value == guest.Gender) || ''}
                                                onChange={(event) => updateGuestDetails('Gender', event.value)}
                                                options={genderOption}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Type <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <Select
                                                id="ddlGuestType" 
                                                name="ddlGuestType"
                                                className="multi-custom"
                                                placeholder="Select Guest Type"
                                                value={guest && guestTypeOption?.find((m) => m.value == guest.Type) || ''}
                                                onChange={(event) => updateGuestDetails('Type', event.value)}
                                                options={guestTypeOption}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Date Of Birth <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8 input-group date">
                                            <input 
                                                id="txtDOB" 
                                                name="txtDOB" 
                                                type="text" 
                                                className="form-control date-input" 
                                                readOnly={true} 
                                                placeholder="Select DOB" 
                                                value={guest.DOB ? moment(guest.DOB).format('DD-MM-YYYY') : ''} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Email </label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input 
                                                id="txtGuestEmail" 
                                                name="txtGuestEmail" 
                                                type="text" 
                                                className="form-control" 
                                                value={guest.Email || ''}
                                                onChange={(event) => updateGuestDetails('Email', event.target.value)} 
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Handicap</label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input 
                                                id="txtGuestHandicap" 
                                                name="txtGuestHandicap" 
                                                type="number" 
                                                className="form-control"
                                                value={guest.Handicap || ''}
                                                onChange={(event) => updateGuestDetails('Handicap', event.target.value)} 
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">IGU Number</label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input 
                                                id="txtIGUNumber" 
                                                name="txtIGUNumber" 
                                                type="text" 
                                                className="form-control" 
                                                value={guest.IGU || ''}
                                                onChange={(event) => updateGuestDetails('IGU', event.target.value)} 
                                            />
                                        </div>
                                    </div>
                                    {isOtpSent && (
                                        <div className="form-group row">
                                            <label className="col-form-label col-lg-3">Enter OTP<span className="red">*</span></label>

                                            <div className="col-xl-4 col-lg-5">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={otp}
                                                    maxLength={6}
                                                    onChange={(e) => setOtp(e.target.value)}
                                                />
                                            </div>

                                            <div className={`col-xl-3 col-lg-4`}>
                                                {canResend ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => handleSendOTP(true)}
                                                        disabled={loadingOtp}
                                                    >
                                                        Resend OTP
                                                    </button>
                                                ) : (
                                                    <span className="font-weight-bold text-danger" >
                                                        Resend in {otpTimer}s
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            {isOtpSent ? (
                                <button type="button" id="btnSaveGuest" name="btnSaveGuest" className="btn btn-brand margin-r5 " onClick={addGuestHandler}>Add Guest</button>
                            ) : (
                             <button  type="button" className="btn btn-primary" onClick={() => handleSendOTP(false)} disabled={loadingOtp}> Get OTP </button>
                            )}
                            
                            <button type="button" className="btn btn-secondary margin-0 margin-r5" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddGuest;